<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref, watch, useId } from "vue"
import NBFormInput from "@/app/Checkout/components/common/NBFormInput/index.vue"
import NBFormSelect from "@/app/Checkout/components/common/NBFormSelect/index.vue"

const props = defineProps({
  countries: {
    type: Array,
    required: true
  },
  label: String,
  phone: String,
  error: String,
  phone_country_code: String,
})

// const selectedCountryPrefix = ref(props.countryCode || "")
const selectedCountry = ref(null)
const localPhone = ref("")
const id = useId()

const emit = defineEmits([
  "update:phone",
  "update:phone_country_code",
])

function updateSelectedCountry() {
  const value = props.phone_country_code
  const normalized = value ? String(value).toUpperCase() : ''
  const match = normalized
    ? props.countries.find(c => String(c.country_code || '').toUpperCase() === normalized)
    : null
  const defaultCode = (typeof window !== 'undefined' && window.config?.country) || 'DE'
  selectedCountry.value =
    match ||
    props.countries.find(c => String(c.country_code || '').toUpperCase() === String(defaultCode).toUpperCase()) ||
    props.countries[0] ||
    null
}

watch(
  () => [props.phone_country_code, props.countries],
  updateSelectedCountry,
  { immediate: true }
)

watch(
  () => props.phone,
  (value) => {
    localPhone.value = value || ""
  },
  { immediate: true }
)

watch(selectedCountry, (country) => {
  emit("update:phone_country_code", country?.country_code || "")
})

watch(localPhone, (value) => {
  const sanitized = String(value || "").replace(/\D/g, "")
  emit("update:phone", sanitized)
})
</script>
